<template>
  <div ref="scollElement">
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_maindiv1">
        <img src="/img/bg1.da3a8e6e.jpg">
        <div class="t_maintxt1">
          <div>提供专业、可信赖的<br>信息化产品服务</div>
          <div>让您的企业生产过程更高效、更安全、更智能</div>
          <div class="t_mainbtn">
            <i class="iconfont iconzu1250"></i>400-152-3152
          </div>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="maindiv1">
        <span class="mainsp1">提供专业、可信赖的信息化产品服务</span><br />
        <span class="mainsp2">10+年软件定制开发经验，专注为客户解决业务痛点</span
        ><br />
        <div class="btnask" @click="onlineChat">
          <span style="font-family:Microsoft YaHei;">在线咨询</span>
        </div>
        <div class="btnreserve" @click="reservation">
          <span style="font-family:Microsoft YaHei;">预约演示</span>
        </div>
        <!-- <div class="mainbtn">
          <i class="iconfont iconzu1250"></i>咨询热线：0513-81193001
        </div> -->
      </div>
    </div>
    <div class="logbg">
      <img src="../assets/img/homepage/logolist.jpg" />
      <!-- <div class="maindiv10" v-for="(item,index) in compsList" :key="index">
            <img :src="item.img">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
              <div class="maindiv11" >
                <span class="mainsp10">{{item.content}}</span>
                <div class="maindiv12"></div>
              </div>
            </transition>
          </div> -->
    </div>
    <div class="t_bcgray" v-if="w_width<888">
      <div class="t_sp1">TMIP产品体系</div>
      <div class="t_sp2">
        TMIP Ver 4.0<br>针对生产管理的各个环节提供专业、可靠的解决方案
      </div>
      <div class="t_maindiv2">
        <div>
          <div class="fx_cs t_sp3" @click="proShow[0].flag=!proShow[0].flag">
            <span>MES 生产管理</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation" v-show="proShow[0].flag">
            <div>
              <img src="/img/1.c96c0c9a.png">
            </div>
            <div>
              针对纺织印染企业的生产过程特点，以生产计划排程、工艺质量控制、品种成本核算、智慧仓储为主要核心模块，推出的生产管理平台
            </div>
            <div @click="goto('/mes')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
        <div>
          <div class="fx_cs t_sp3" @click="proShow[1].flag=!proShow[1].flag">
            <span>WMS 智慧仓储</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation2" v-show="proShow[1].flag">
            <div>
              <img src="/img/2.d5a8e69d.png">
            </div>
            <div>
              根据实际货物存储要求（集中存放、先进先出等），由系统自动规划入仓存放、出仓配货库位。基于3D虚拟现实技术，实现仓库的可视化管理，快速定位，提升作业效率
            </div>
            <div  @click="goto('/wms')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
        <div>
          <div class="fx_cs t_sp3" @click="proShow[2].flag=!proShow[2].flag">
            <span>MTR 物料溯源</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation2" v-show="proShow[2].flag">
            <div>
              <img src="/img/3.23806ca2.png">
            </div>
            <div>
              应用生产过程中的物料标签（条码、RFID），从原料投入开始，包括中间工序在内，通过移动掌机记录工序投入、产出物料标签，实现产成品溯源的目标，提升物料质量管理水平
            </div>
            <div @click="goto('/mtr')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
        <div>
          <div class="fx_cs t_sp3" @click="proShow[3].flag=!proShow[3].flag">
            <span>EMV 生产可视化</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation2" v-show="proShow[3].flag">
            <div>
              <img src="/img/4.ec101536.png">
            </div>
            <div>
              应用数据孪生技术，对生产过程进行镜像，核验工艺条件参数与设备实际生产参数的一致性，按设定的阈值对结果进行比对、控制，多渠道触达相关人员，提升加工质量管理水平
            </div>
            <div @click="goto('/emv')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bcgray" v-else>
      <div class="widtol maindiv2">
        <div style="text-align:left">
          <span class="mainsp3" style="display:inline-block">产品体系</span>
          <span class="mainsp4" style="margin-left:20px;"
          >
          针对生产管理的各个环节提供专业、可靠的解决方案</span
        >
        </div>
        <div class="maindiv3 mainflex">
          <div
            class="maindiv5"
            style="margin-right: 30px"
            
          >
          <!-- @mouseover="animatein1"
            @mouseleave="animateout1"
            @click="goto('/mes')" -->
            <!-- <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv7" v-show="show1">
                <span class="mainsp6">MES 生产管理</span>
                <span class="mainsp7"
                  >针对纺织印染企业的生产过程特点，以生产计划排程、工艺质量控制、品种成本核算、智慧仓储为主要核心模块，推出的生产管理平台。</span>
                <i class="iconfont iconzu353"></i>
              </div>
            </transition> -->
            <!-- <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show1">
                <img src="../assets/img/homepage/aboutTMIP.jpg" />
                <span class="mainsp5">MES 生产管理</span>
              </div>
            </transition> -->
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutTMIP.jpg" />
                <div >
                <span class="mainsp5">TMIP®纺织印染</span>
                <span class="mainsp51">为纺织印染行业量身定制，以生产计划排程、工艺质量控制、品种成本核算、智慧仓储为主要核心模块，推出的生产管理平台</span>
                </div>
              </div>
          </div>
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutDMIP.jpg" />
                <div >
                <span class="mainsp5">DMIP®羽绒生产管理</span>
                <span class="mainsp51">为羽绒生产行业量身定制，针对原料采购、生产加工、标签打印、库存管理等核心场景进行一体化管理</span>
                </div>
              </div>
          </div>
          <!-- <div
            class="maindiv5"
            @mouseover="animatein2"
            @mouseleave="animateout2"
            @click="goto('/wms')"
          >
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv7" v-show="show2">
                <span class="mainsp6">WMS 智慧仓储</span>
                <span class="mainsp7"
                  >根据实际货物存储的要求（集中存放、先进先出等），
                  由系统自动规划入仓存放、出仓配货库位。
                  基于3D虚拟现实技术，实现3D仓库的可视化管理，
                  快速定位，提升作业效率。</span
                >
                <i class="iconfont iconzu353"></i>
              </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show2">
                <img src="../assets/img/homepage/2.png" />
                <span class="mainsp5">WMS 智慧仓储</span>
              </div>
            </transition>
          </div> -->
        </div>
        <div class="maindiv4 mainflex">
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutMA.jpg" />
                <div >
                <span class="mainsp5">设备维修管理</span>
                <span class="mainsp51">一键扫码报修，使用数字化协同管理方式,提高设备维修效率、降低维护成本，助力企业优化投资回报</span>
                </div>
              </div>
          </div>
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutWMA.jpg" />
                <div >
                <span class="mainsp5">化工仓储管理</span>
                <span class="mainsp51">专为化工行业打造，精准库存管理、生产质量监控、保管到期提醒等。 帮助工厂提高货品质量、降本增效</span>
                </div>
              </div>
          </div>
          <!-- <div
            class="maindiv5"
            style="margin-right: 30px"
            @mouseover="animatein3"
            @mouseleave="animateout3"
            @click="goto('/mtr')"
          >
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv7" v-show="show3">
                <span class="mainsp6">MTR 物料溯源</span>
                <span class="mainsp7"
                  >应用生产过程中的物料标签（条码、RFID），
                  从原料投入开始，包括中间工序在内，
                  通过移动掌机记录工序投入、产出物料标签，
                  从而实现产成品溯源的目标，提升物料质量管理水平。</span
                >
                <i class="iconfont iconzu353"></i>
              </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show3">
                <img src="../assets/img/homepage/3.png" />
                <span class="mainsp5">MTR 物料溯源</span>
              </div>
            </transition>
          </div> -->
          <!-- <div
            class="maindiv5"
            @mouseover="animatein4"
            @mouseleave="animateout4"
            @click="goto('/emv')"
          >
          <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
            <div class="maindiv7" v-show="show4">
              <span class="mainsp6">EMV 生产可视化</span>
              <span class="mainsp7"
                >应用数据孪生技术，对生产过程进行镜像，
                核验工艺条件参数与设备实际生产参数的一致性，
                按设定的阈值对结果进行比对、控制，
                多渠道触达相关人员，提升加工质量管理水平。</span
              >
              <i class="iconfont iconzu353"></i>
            </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show4">
                <img src="../assets/img/homepage/4.png" />
                <span class="mainsp5">EMV 生产可视化</span>
              </div>
            </transition>
            
          </div> -->
        </div>
        <div class="maindiv4 mainflex">
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutEMA.jpg" />
                <div >
                <span class="mainsp5">能耗监控系统</span>
                <span class="mainsp51">通过集中监测水、电、气、压力、冷、热等能耗数据，进行实时用能监控和分析，为实现能耗双控提供解决方案</span>
                </div>
              </div>
          </div>
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutFTrade.jpg" />
                <div >
                <span class="mainsp5">面料贸易系统</span>
                <span class="mainsp51">专为化工行业打造，精准库存管理、生产质量监控、保管到期提醒等。帮助工厂提高货品质量、降本增效</span>
                </div>
              </div>
          </div>
        </div>
        <div class="maindiv4 mainflex">
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutQCS.jpg" />
                <div >
                <span class="mainsp5">面料疵点检验系统</span>
                <span class="mainsp51">面料疵点信息可记录、疵点数据可分析、疵点记录可追溯是纺织企业精确管控产品质量的基本要求，为每台验布机配置VCANS智能验布终端与标签打印机</span>
                </div>
              </div>
          </div>
          <div
            class="maindiv5"
            style="margin-right: 30px"   
          >
            <div class="maindiv6" v-show="!show1">
                <img class="detailimgfont" src="../assets/img/homepage/aboutEquipmentmonitoring.jpg" />
                <div >
                <span class="mainsp5">设备监控大屏</span>
                <span class="mainsp51">面料疵点信息可记录、疵点数据可分析、疵点记录可追溯是纺织企业精确管控产品质量的基本要求，为每台验布机配置VCANS智能验布终端与标签打印机</span>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="t_bcWhite" v-if="w_width<888">
      <div class="t_txt5">我们的客户</div>
      <div class="t_txt6">
        已为多家大型生产型企业提供信息化服务，<br>深入了解企业管理痛点，提出信息化解决方案。 <br>
        通过信息化手段，实现生产进度可跟踪、生产品质可追溯、生产成本可分析，为企业提供安全可靠的数据分析平台
      </div>
      <div style="width: 93.4%;margin: 0 0 0 3.3%">
        <img :src="item.img" v-for="(item,index) in compsList" :key="index" style="width: 34.2%;margin: 10px 7.9%">
      </div>
    </div>
    <!-- <div class="bcwhite" v-else>
      <div class="widtol maindiv8">
        <span class="mainsp8">我们的客户</span>
        <span class="mainsp9">已为多家大型生产型企业提供信息化服务，深入了解企业管理痛点，提出信息化解决方案。
          <br> 通过信息化手段，实现生产进度可跟踪、生产品质可追溯、生产成本可分析，为企业提供安全可靠的数据分析平台。</span>
        <div class="maindiv9">
          <div class="maindiv10" v-for="(item,index) in compsList" :key="index">
            <img :src="item.img">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
              <div class="maindiv11" >
                <span class="mainsp10">{{item.content}}</span>
                <div class="maindiv12"></div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div> -->
    <div class="t_bcgray" style="padding: 37px 0" v-if="w_width<888">
      <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="t_txt4">阶段一：需求确认</div>
              <img src="../assets/img/homepage/c1.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1260 mainicon"></i>
                    </div>
                    <span class="t_txt7">需求调研</span>
                  </div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1261 mainicon"></i>
                    </div>
                    <span class="t_txt7">合同签订</span>
                  </div>
                </div>
                <div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1259 mainicon"></i>
                    </div>
                    <span class="t_txt7">方案及预算</span>
                  </div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconlujing3280 mainicon"></i>
                    </div>
                    <span class="t_txt7">制定项目计划</span>
                  </div>
                </div>
              </div>
              <div class="t_icon4">
                <div class="t_maindiv21">
                  <i class="iconfont iconlujing3280 mainicon"></i>
                </div>
                <span class="t_txt7">制定项目计划</span>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段二：项目研发</div>
              <img src="../assets/img/homepage/c2.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3279 mainicon"></i>
                  </div>
                  <span class="t_txt7">功能研发</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconzu1258 mainicon"></i>
                  </div>
                  <span class="t_txt7">项目测试</span>
                </div>
              </div>
              <div class="t_txt8">
                每周输出项目进度报告<br>帮助客户实时了解研发进度
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段三：交付验收</div>
              <img src="../assets/img/homepage/c3.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3281 mainicon"></i>
                  </div>
                  <span class="t_txt7">实施交付</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconzu1263 mainicon"></i>
                  </div>
                  <span class="t_txt7">使用培训</span>
                </div>
              </div>
              <div class="t_txt8">
                根据阶段一的功能设计书进行功能验收<br>验收条目清晰可查
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段四：运维支持</div>
              <img src="../assets/img/homepage/c4.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3283 mainicon"></i>
                  </div>
                  <span class="t_txt7">专属客户<br>经理对接</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3282 mainicon"></i>
                  </div>
                  <span class="t_txt7">工作日<br>24小时响应</span>
                </div>
              </div>
              <div class="t_txt8">
                将反馈内容登记到课题表<br>每周进行跟进汇报
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="bcgray" v-else>
      <div class="widtol maindiv13">
        <span class="mainsp8 textleft" style="margin-bottom:18px;">服务流程</span>
        <span class="mainsp9 textleft" style="font: normal normal normal 20px/32px Microsoft YaHei;">无缝对接、专业服务流程</span>
        <div class="maindiv14">
          <div v-for="(show,idx) in shows" :key="idx">
            <div class="maindiv15" @click="addclass(idx)" :class="selectedshow == idx ?'selected':''">
              <img :src="show.img">
            </div>
            <span class="mainsp11">{{show.content}}</span>
          </div>
        </div>
        <!-- 需求确认 -->
        <div class="maindiv16" v-show="selectedshow == '0'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c1.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1260 mainicon"></i>
                    </div>
                    <span class="mainsp12">需求调研</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1259 mainicon"></i>
                    </div>
                    <span class="mainsp12">方案及预算</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1261 mainicon"></i>
                    </div>
                    <span class="mainsp12">合同签订</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3280 mainicon"></i>
                    </div>
                    <span class="mainsp12">制定项目计划</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1262 mainicon"></i>
                    </div>
                    <span class="mainsp12">交互设计书 / 功能设计书</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 项目研发 -->
        <div class="maindiv16" v-show="selectedshow == '1'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c2.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3279 mainicon"></i>
                    </div>
                    <span class="mainsp12">功能研发</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1258 mainicon"></i>
                    </div>
                    <span class="mainsp12">项目测试</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24" style="padding:0 10px">
                  <span class="mainsp13">在项目研发阶段，每周输出项目进度报告，帮助客户实时<br>了解研发进度</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 交付验收 -->
        <div class="maindiv16" v-show="selectedshow == '2'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c3.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3281 mainicon"></i>
                    </div>
                    <span class="mainsp12">实施交付</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1263 mainicon"></i>
                    </div>
                    <span class="mainsp12">使用培训</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24" style="padding:0 10px">
                  <span class="mainsp13">在实施交付阶段，根据阶段一的功能设计书进行<br>功能验收，验收条目清晰可查</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 运维支持 -->
        <div class="maindiv16" v-show="selectedshow == '3'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c4.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="12">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3283 mainicon"></i>
                    </div>
                    <span class="mainsp12">专属客户经理对接</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3282 mainicon"></i>
                    </div>
                    <span class="mainsp12">工作日24小时响应</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24" style="padding:0 10px">
                  <span class="mainsp13">在实施交付阶段，根据阶段一的功能设计书进行功能验收，验收条目清晰可查</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="boxShow=false">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" >TMIP纺织印染</div>
          <div class="t_t_list">DMIP羽绒生产管理</div>
          <div class="t_t_list" >设备维修管理</div>
          <div class="t_t_list" >化工仓储管理</div>
          <div class="t_t_list" >能耗监控管理</div>
          <div class="t_t_list" >面料贸易管理</div>
          <!-- <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div> -->
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
    <!-- 预约演示 -->
    <el-dialog title="预约演示" class="dialogstyle" :visible.sync="showflg" width="455px" :before-close="handleClose" :close-on-click-modal="false">
      <div>
        <span>请留下您的联系方式，稍后客户经理会与您联系</span>
      </div>
      <el-form class="formfont" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="姓名" prop="name" >
          <el-input v-model="ruleForm.name" size="small" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phonenum">
          <el-input v-model="ruleForm.phonenum" size="small" placeholder="请输入" ></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" resize="none" :rows="2" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center;">
        <el-button type="primary" @click="beforesubmit">提交</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import util from "../components/util";
import Swiper from "swiper";
export default util.useCommon({
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      showflg:false,
      selectedshow:'0',
      ruleForm:{
        name:'',
        phonenum:'',
        desc:''
      },
      rules:{
        name:
        [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phonenum:
        [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          // { validator: (rule, value, callback) => {
          //     const phoneRegex = /^1\d{10}$/;
          //     const landlineRegex = /^(0\d{3,4}-?)?\d{7,8}$/;
          //     if (phoneRegex.test(value) || landlineRegex.test(value)) {
          //       callback();
          //     } else {
          //       callback(new Error('请输入有效的11位手机号或座机号'));
          //     }
          //   }, trigger: 'blur' }
          // { pattern: /^1[3-9]\d{9}$/, message: '电话号码格式不正确', trigger: 'blur' }
        ],
        desc:
        [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
      },
      compsList:[
        {
          img:require ('../assets/img/homepage/a1.jpg'),
          content:'帝人集团',
        },
        {
          img:require ('../assets/img/homepage/a2.jpg'),
          content:'东丽集团'
        },
        {
          img:require ('../assets/img/homepage/a3.jpg'),
          content:'OKI'
        },
        {
          img:require ('../assets/img/homepage/a4.jpg'),
          content:'王子制纸'
        },
        {
          img:require ('../assets/img/homepage/a5.jpg'),
          content:'万方'
        },
        // {
        //   img:require ('../assets/img/homepage/a6.jpg'),
        //   content:'凯尔文'
        // },
        {
          img:require ('../assets/img/homepage/a7.jpg'),
          content:'东隆集团'
        },
        // {
        //   img:require ('../assets/img/homepage/a8.jpg'),
        //   content:'远吉织染'
        // },
        {
          img:require ('../assets/img/homepage/a9.jpg'),
          content:'格林兰'
        },
        {
          img:require ('../assets/img/homepage/a10.jpg'),
          content:'宇泽印染'
        },
        {
          img:require ('../assets/img/homepage/a11.jpg'),
          content:'ANS株式会社'
        },
        // {
        //   img:require ('../assets/img/homepage/a12.jpg'),
        //   content:'南华纺织'
        // },
      ],
      shows: [
        {
          img:require('../assets/img/homepage/b1.png'),
          content:'需求确认'
        },
        {
          img:require('../assets/img/homepage/b2.png'),
          content:'项目研发'
        },
        {
          img:require('../assets/img/homepage/b3.png'),
          content:'交付验收'
        },
        {
          img:require('../assets/img/homepage/b4.png'),
          content:'运维支持'
        },
      ],
      w_width:0,
      activeNames:1,
      proShow:[{flag:false},{flag:false},{flag:false},{flag:false}],
      boxShow: false,
      listShow:true,
      w_height:0,
    };
  },
  watch: {},
  methods: {
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
      // this.$nextTick(() => {
      //   if (this.$refs.scollElement) {
      //     // 滚动元素跳转到顶部
      //     this.$refs.scollElement.scrollTop = -520;
      //   }
      // });
    },
    onlineChat(){
      window.open("https://work.weixin.qq.com/kfid/kfc50bdbcc9f77896c3");
    },
    reservation(){
      this.showflg = true;
    },
    handleClose(){
      this.showflg = false;
      this.ruleForm.name = '';
      this.ruleForm.phonenum = '';
      this.ruleForm.desc = '';
      this.$refs.ruleForm.resetFields();
    },

    addclass(idx){
      var v = this;
      
      v.selectedshow = idx;
    },
    beforesubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if(valid){
          this.submit()
        }else{
          return;
        }
      })
    },
    submit(){
      var v = this;
      const data = {
        "msgtype":"text",
        "text":{
          "content":`预约：姓名：${v.ruleForm.name} ；电话：${v.ruleForm.phonenum} ；公司名称：${v.ruleForm.desc}`
        }
      };

      // 目标URL
      const url = 'https://oapi.dingtalk.com/robot/send?access_token=4fd80dd2a2d470516b00b674a48d944c4dc8234b822c0858a99f40b5702fe992';
      const proxyUrl = 'https://cros.nyy.com.cn/';

      // 使用fetch发送POST请求
      fetch(proxyUrl + url, {
          method: 'POST', // 请求方法
          headers: {
              'Content-Type': 'application/json' // 设置请求头，表示发送JSON数据
          },
          body: JSON.stringify(data) // 将JavaScript对象转换为JSON字符串
      })
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json(); // 将响应解析为JSON
      })
      .then(data => {
          console.log('Success:', data); // 处理响应数据
      })
      .catch(error => {
          console.error('Error:', error); // 处理错误
      });
      v.handleClose();
    },
    // ///////////////////    以下都可以注释
    animatein1() {
      this.show1 = true;
    },
    animateout1() {
      this.show1 = false;
    },
    animatein2() {
      this.show2 = true;
    },
    animateout2() {
      this.show2 = false;
    },
    animatein3() {
      this.show3 = true;
    },
    animateout3() {
      this.show3 = false;
    },
    animatein4() {
      this.show4 = true;
    },
    animateout4() {
      this.show4 = false;
    },
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    }
  },
  mounted() {
    console.log(window.innerWidth);
    this.w_width = window.innerWidth;
    this.w_height = window.innerHeight;
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 24,
      autoplay: {
        disableOnInteraction: false,
        delay: 2000,
      },
    });
  },
  activated() {},
});
</script>
<style lang="less" scoped>
.header {
  background-image: url(../assets/img/homepage/bg12.jpg);
  min-width: 1300px;
  height: 570px; 
}
.maindiv1 {
  // text-align: center;
  padding-top: 170px;
  padding-left: 21vw;
}
.mainsp1 {
  font: normal normal normal 46px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.mainsp2 {
  font: normal normal 300 24px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  display: inline-block;
  margin: 30px 0 50px 0;
}
.mainbtn {
  font: normal normal normal 18px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  width: 320px;
  margin: 0 auto;
  background-color: #537bfe;
  border-radius: 27px;
  overflow: hidden;
  cursor: default;
}

.iconzu1250 {
  margin-right: 10px;
  font-size: 20px;
  position: relative;
  top: 2px;
}

.maindiv2 {
  padding: 50px 0 0px 0;
  text-align: center;
}

.mainsp3 {
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  display: block;
  margin-bottom: 10px;
}
.mainsp4 {
  font: normal normal normal 20px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717b81;
}
.maindiv3 {
  padding-top: 50px;
}
.maindiv4 {
  padding-top: 30px;
}
.mainflex {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 0 auto;
}
.maindiv5 {
  width: 528px;
  height: 360px;
  background: #ffffff;
  box-shadow: 0px 0px 6px #3e548229;
  border-radius: 8px;
  position: relative;
  // cursor: pointer;
}
.maindiv6 {
  margin: 0 auto;
  // padding-top: 60px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.maindiv6 img {
  // width: 200px;
  // height: 200px;
  width: 513px;
  height: auto;
}
.maindiv6 div {
  padding:0 10px 0 20px;
  text-align:left
}

.mainsp5 {
  display: block;
  margin-top: 15px;
  font: normal normal bold 22px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}
.mainsp51 {
  display: block;
  margin-top: 15px;
  font: normal normal  14px/20px Source Han Sans CN;
  letter-spacing: 0px;
  color: #717B81;
}
.maindiv7 {
  width: 100%;
  height: 100%;
  background-color: #536dfe;
  border-radius: 8px;
  position: relative;
  padding: 90px 40px 0;
  text-align: center;
  color: #ffffff;
}
.maindiv7 .iconfont{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  font-size: 26px;
}

.mainsp6 {
  font: normal normal bold 22px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #ffffff;
  display: block;
  margin-bottom: 30px;
}
.mainsp7 {
  font: normal normal normal 16px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
}


.maindiv8{
  padding: 90px 0 130px;
  text-align: center;
}
.mainsp8{
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  display: block;
  margin-bottom: 28px;
}
.mainsp9{
  font: normal normal normal 18px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
}
.maindiv9{
  display: flex;
  width: 100%;
  padding-top: 50px;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.maindiv10{
  width: 156px;
  height: 91px;
  margin-top: 34px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px #3E548229;
  position: relative;
}
.maindiv10 img{
  width: 100%;
  height: 100%;
}
.maindiv11{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0.9;
  background-color: #536DFE;
  border-radius: 8px;
  display: none;
  white-space: nowrap;
  padding-top: 26px;
}
.maindiv10:hover{
  .maindiv11{
    display: block;
    animation: fade-in;/*动画名称*/  
    animation-duration: .3s;/*动画持续时间*/  
    -webkit-animation:fade-in .3s;/*针对webkit内核*/  
  }

}
.mainsp10{
  font: normal normal 300 18px/30px Microsoft YaHei;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}

.maindiv12{
  width: 30px;
  height: 2px;
  background-color: #ffffff;
  margin: 0 auto;
}

@keyframes fade-in {  
    0% {opacity: 0;}/*初始状态 透明度为0*/  
    30% {opacity: 0.5;}
    50% {opacity: 0.7;}/*过渡状态 透明度为0*/  
    80% {opacity: 0.8;}
    100% {opacity: 0.9;}/*结束状态 透明度为1*/  
}  
@-webkit-keyframes fade-in {/*针对webkit内核*/  
    0% {opacity: 0;}  
    30% {opacity: 0.5;}
    50% {opacity: 0.7;}  
    80% {opacity: 0.8;}
    100% {opacity: 0.9;}  
}  

.maindiv13{
  padding: 100px 0;
  text-align: center;
}

.maindiv14{
  padding: 0 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow: hidden;
}
.maindiv15{
  width: 127px;
  height: 127px;
  border-radius: 50%;
  margin: 34px 0 12px 0;
  // overflow: hidden;
  position: relative;
}
.maindiv15:hover{
  cursor: pointer;
  background-color: #ffffff;
}

.maindiv15 img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.maindiv15::before{
  content: '';
  width: 110px;
  height: 3px;
  background-color: #D8DBEF;
  position: absolute;
  right: -144px;
  top: 50%;
}

.mainsp11{
  font: normal normal bold 22px/30px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}

.selected{
  border: #536DFE 1px solid;
  background-color: #ffffff;
}

.maindiv16{
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 17px;
  background-color: #ffffff;
  margin-top: 40px;
  padding: 60px 80px;
}
.maindiv17{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.maindiv18,.maindiv19{
  width: 50%;
}
.maindiv18{
  padding-right: 30px;
}
.maindiv18 img{
  width: 430px;
  height: 240px;
  // width: 100%;
  // height: auto;
}
.maindiv19{
  padding-left: 30px;
}
.maindiv21{
  box-shadow: 0px 3px 6px #6B8DC829;
  background-color: #ffffff;
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
}
.mainicon{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  font-size: 16px;
  font-weight: bold;
  color: #536DFE;
}
.mainicon1{
  font-size: 20px;
  color: #C5CAE9;
  position: relative;
  top: 10px;
}
.mainsp12{
  font: normal normal bold 18px/26px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}
.maindiv22{
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.maindiv20{
  padding: 15px 0 20px;
  text-align: left;
}

.mainsp13{
  font: normal normal normal 15px/28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
}
.animation{
  animation:myTab2 1s;
  -webkit-animation:myTab 1s; /*Safari and Chrome*/
  position: absolute;
  top: 0;
}
  
@keyframes  myTab2{
  from{top:  -310px;}
  to{top: 0;}
}
.swiper-container {
  width: 100%;
  height: 490px;
}
.swiper-slide {
  width: 60%;
  width: 84%;
  padding: 45px 8%;
  background: #FFFFFF;
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 10px #3e548229;
  box-shadow: 0px 0px 10px #3e548229;
  height: 477px;
}
.btnask{
  border: 1px solid #FFFFFF;
  border-radius: 4px;
  opacity: 1;
  padding: 12px 33px;
  width: 133px;
  height: 46px;
  display: inline-block;
  cursor: pointer;
  span{
    color: #fff;
    font-size: 16px;
  }
}
.btnreserve{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  padding: 12px 33px;
  width: 133px;
  height: 46px;
  display: inline-block;
  margin-left: 30px;
  cursor: pointer;
  span{
    color: #1C4BCC;
    font-size: 16px;
  }
}
.logbg{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #8288B129;
  opacity: 1;
  height: 75px;
  display: flex;
  padding: 13px 0;
  img{
    width: 1086px;
    height: auto;
    margin: auto;
  }
}
.textleft{
  text-align: left;
  display: block;
}
.dialogstyle ::v-deep .el-dialog__header{
  padding:20px 60px 10px 50px;
}
.dialogstyle ::v-deep .el-dialog__title{
  font-weight: bold;
}
.dialogstyle ::v-deep .el-dialog__body{
  // padding-top: 10px;
  padding:10px 60px 30px 50px;
}
.dialogstyle{
  span{
    color: #717B81;
    font-size: 16px;
    margin-bottom: 25px;
    display: block;
  }
  .el-button{
    width: 100px;
  }
}

.formfont{
  padding-right: 40px;
  margin-bottom: 70px;
}
::v-deep .el-form-item__label{
  font-weight: bold;
}
::v-deep .el-textarea__inner{
  font-family: none;
}
</style>
